import { useTranslate } from 'react-polyglot';

import { RoundedButton, useBreakpoint } from '@genially/design-system';
import { CloseIcon } from '@genially/icons';

import { RouteNames } from '../../../../../../../../bootstrap/domain/RouteNames';
import { QRCode } from '../../../../../../../../shared/application/components/QRCode/QRCode';
import { useNavigation } from '../../../../../../../../shared/application/hooks/useNavigation';
import { splitSessionCodeByDash } from '../../../../../../../../shared/application/utils/splitSessionCodeByDash';
import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { HostGameBreakdownSteps } from '../../HostGame.constants';
import { Header } from '../Sidebar/Sidebar.styled';
import { CopyLinkAction } from './components/CopyLinkAction/CopyLinkAction';
import { ShareLinkAction } from './components/ShareLinkAction/ShareLinkAction';
import {
  Content,
  InnerWrapper,
  QRCodeWrapper,
  SessionCode,
  Subtitle,
  Wrapper,
} from './InviteSidebar.styled';

interface InviteSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const InviteSidebar = ({ isOpen, onClose }: InviteSidebarProps) => {
  const t = useTranslate();
  const { client } = useHostClientContext();
  const { getFullUrl } = useNavigation();
  const { isDownwards } = useBreakpoint();

  const isMobile = isDownwards(HostGameBreakdownSteps.forth);

  const { geniallyId, sessionId } = client;

  const qrUrl = `${getFullUrl({
    to: RouteNames.PlayerUsernameSelection,
    params: { geniallyId, sessionId },
  })}?from=game`;

  return (
    <Wrapper data-cy="inviteSidebar" data-open={isOpen} $isOpen={isOpen}>
      <InnerWrapper>
        <Header>
          <RoundedButton
            Icon={<CloseIcon />}
            variant={RoundedButton.Variant.PRIMARY}
            size={RoundedButton.Size.SMALL}
            onClick={onClose}
            aria-label={t('__new.play.analyticsResults.close')}
            dataCy="closeInviteSidebar"
          />
        </Header>

        <Content>
          <QRCodeWrapper>
            <QRCode
              url={qrUrl}
              sessionId={splitSessionCodeByDash(sessionId)}
              geniallyId={geniallyId}
              openedFrom="game"
              isLarge
            />
          </QRCodeWrapper>

          <Subtitle>{t('__new.play.creatorLobby.copyLink.subtitle')}</Subtitle>

          <SessionCode>{splitSessionCodeByDash(sessionId)}</SessionCode>

          {isMobile ? <ShareLinkAction /> : <CopyLinkAction />}
        </Content>
      </InnerWrapper>
    </Wrapper>
  );
};
